import React from "react";
import { Outlet } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import banner from "../../../../public/imgs/banner.webp";
import { test } from "./ClientDescription";

const PublicLayout = () => {
    const navigate = useNavigate();

    const hostname = window.location.hostname; // ex: "epv.hordyplan.fr"
    const sub_domain = hostname.split(".")[0];

    return (
        <div className="flex h-screen bg-gray-100">
            {/* Section Gauche avec Image et Texte, cachée sur mobile */}
            <div className="hidden lg:w-1/2 lg:block relative">
                <img
                    src={test[sub_domain]?.logo || banner}
                    alt="Logo"
                    className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-black/50 flex flex-col justify-center items-center text-center p-10 text-white">
                    <h1
                        className="text-4xl font-bold cursor-pointer"
                        onClick={() => navigate("/")}
                    >
                        {test[sub_domain]?.name ||
                            "Logiciel Gestion de Temps et d'activités "}
                    </h1>
                    <p
                        className="text-lg mt-4 cursor-pointer"
                        onClick={() => navigate("/")}
                    >
                        {test[sub_domain]?.description || "(GTA)"}
                    </p>
                </div>
            </div>
            <Outlet />
        </div>
    );
};

export default PublicLayout;
